module.exports = __webpack_public_path__ + "src/img/kankan.d1341e80.svg";